var map = {
	"./file_audio.png": "b6f8",
	"./file_excel.png": "e464",
	"./file_exe.png": "5834",
	"./file_html.png": "833d",
	"./file_img.png": "06a8",
	"./file_other.png": "4a10",
	"./file_pdf.png": "7908",
	"./file_txt.png": "ab5b",
	"./file_video.png": "3f66",
	"./file_word.png": "4d26",
	"./file_zip.png": "e3d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a56f";